import React from "react";
import styled from "@emotion/styled";
import {
  COLOR_VARIANTS,
  CurrencySymbol,
  TYPOGRAPHY_VARIANT,
} from "@tajawal/ct-web-design-system";
import { SAR } from "@/constants/common.constants";

export function utilFormatSARToRiyal(
  disclaimer: string,
  color: COLOR_VARIANTS | null = null,
) {
  return <FormatSARToRiyalSymbol disclaimer={disclaimer} color={color} />;
}

const StyledWrapper = styled.div`
  & > div {
    display: inline;
    margin-bottom: 5px;
  }
`;

type FormatSARToRiyalSymbolProps = {
  disclaimer: string;
  color?: COLOR_VARIANTS | null;
  variant?: TYPOGRAPHY_VARIANT | null;
};

export function FormatSARToRiyalSymbol({
  disclaimer,
  color = null,
  variant = TYPOGRAPHY_VARIANT.BODY2,
}: FormatSARToRiyalSymbolProps): JSX.Element {
  if (!disclaimer) return null;
  if (typeof disclaimer !== "string") return disclaimer;

  return (
    <StyledWrapper>
      {disclaimer.split(/(SAR\s*[\d,]+|[\d,]+\s*SAR)/g).map((part) => {
        const match = part.match(/^(?:SAR\s*([\d,]+)|([\d,]+)\s*SAR)$/);
        if (match) {
          const digits = match[1] || match[2];

          return (
            <React.Fragment key={part}>
              <CurrencySymbol variant={variant} color={color} currency={SAR}>
                {digits}
              </CurrencySymbol>
            </React.Fragment>
          );
        }
        return (
          <span
            style={{
              display: "inline",
            }}
          >
            {part}
          </span>
        );
      })}
    </StyledWrapper>
  );
}

export default FormatSARToRiyalSymbol;
